import axios from "axios";

let baseUrl = process.env.REACT_APP_BACKEND_URL;
if (!baseUrl) {
  baseUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:8080"
      : "";
}
baseUrl = baseUrl.replace(/\/+$/, "");

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
